import script from "./AddCompanyContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCompanyContactModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCompanyContactModal.vue?vue&type=style&index=0&id=563711b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563711b8"]])

export default __exports__